var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.terms.length)?_c('div',{staticClass:"nav"},[_c('div',{staticClass:"container navBox"},_vm._l((_vm.terms),function(item,index){return _c('a',{key:index,staticClass:"navItem noSelect",attrs:{"href":("/classify?term_id=" + (item.term_id || ''))},on:{"click":function($event){$event.preventDefault();return _vm.userClick('classify', {
				term_id: item.term_id
			})}}},[_vm._v("\n\t\t\t"+_vm._s(item.name)+"\n\t\t")])}),0)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d888396","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/Nav.vue
// module id = null
// module chunks = 